// 这个调用后台接口生成
export const permissionMap = {
  "采购-预采购单-查看": 199,
  "采购-预采购单-新增": 200,
  "采购-预采购单-编辑": 201,
  "采购-预采购单-删除": 202,
  "采购-采购单-查看": 204,
  "采购-采购单-新增": 205,
  "采购-采购单-编辑": 206,
  "采购-采购单-删除": 207,
  "采购-调货单-查看": 209,
  "采购-调货单-新增": 210,
  "采购-调货单-编辑": 211,
  "采购-调货单-删除": 212,
  "商品-商品管理-查看": 215,
  "商品-商品管理-新增": 216,
  "商品-商品管理-编辑": 217,
  "商品-商品管理-删除": 218,
  "商品-商品溯源-查看": 220,
  "商品-商品保质期-查看": 222,
  "商品-商品保质期-新增": 223,
  "商品-商品保质期-删除": 224,
  "库存-库存查询-查看": 227,
  "库存-库存盘点-查看": 229,
  "库存-库存盘点-盘点": 230,
  "销售-销售单-查看": 233,
  "销售-销售单-新增": 234,
  "销售-销售单-编辑": 235,
  "销售-销售单-删除": 236,
  "销售-外卖单-查看": 238,
  "销售-外卖单-建单": 239,
  "销售-外卖单-下载": 240,
  "销售-报价单-查看": 242,
  "销售-报价单-新增": 243,
  "销售-报价单-编辑": 244,
  "销售-报价单-删除": 245,
  "财务-应收款-查看": 248,
  "财务-应付款-查看": 250,
  "财务-财务流水-查看": 252,
  "财务-财务流水-撤销": 285,
  "报表-商品分析-查看": 255,
  "报表-库存分析-查看": 257,
  "报表-采购分析-查看": 259,
  "报表-销售分析-查看": 261,
  "报表-员工绩效-查看": 263,
  "报表-客户分析-查看": 265,
  "报表-数据大屏-查看": 267,
  "配置-资金账户-查看": 270,
  "配置-资金账户-新增": 271,
  "配置-资金账户-编辑": 272,
  "配置-资金账户-删除": 273,
  "配置-客户管理-查看": 275,
  "配置-客户管理-新增": 276,
  "配置-客户管理-编辑": 277,
  "配置-客户管理-删除": 278,
  "配置-供应商管理-查看": 280,
  "配置-供应商管理-新增": 281,
  "配置-供应商管理-编辑": 282,
  "配置-供应商管理-删除": 283,
  "商品-交易记录-查看": 286
};



// WEBPACK FOOTER //
// ./src/store/permissionMap.js